import React, { Component } from 'react'
import { Spin, Form, Layout, PageHeader} from 'antd'
import {systemMessageDetail} from '_src/api/api'
import './style.less'

@Form.create({name: ''})
class MessageDetail extends Component {
  state = {
    isLoading: true,
  }
  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    systemMessageDetail({id})
      .then(res => {
        this.setState({
          info: res.data,
          isLoading: false,
        })
      })
  }

  render () {
    const {
      info,
      isLoading,
    } = this.state
    return (
      <Layout className="message-detail-page" style={{ padding: 20, paddingTop: 40, paddingLeft: 50, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PageHeader className='flex-h-a' title='查看系统消息' style={{borderLeft: '5px solid #1890ff', height: 30}} />
        {
          info && (
            <div className="detail-inner" style={{paddingTop: 20}}>
              <div className="header-content">
                <div className="title">{info.title}</div>
                <div className="date-tag">
                  <span>发布时间：{info.createAt}</span>
                  <span style={{marginLeft: 20}}>发布人：{info.admin.name}</span>
                </div>
              </div>
              <div className="belly-content">
                <div dangerouslySetInnerHTML={{__html: info.content}} style={{width: 600}} />
              </div>
            </div>
          )
        }
      </Layout>
    )
  }
}

export default MessageDetail